import React from 'react'

const PencilIcon = () => {
  return (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="inherit" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M19.8 2.39565C19.3225 2.39565 18.8646 2.58499 18.5269 2.92202L17.5755 3.87176L20.1216 6.41329L21.0731 5.46354C21.4107 5.12652 21.6004 4.66941 21.6004 4.19278C21.6004 3.71615 21.4107 3.25904 21.0731 2.92202C20.7354 2.58499 20.2775 2.39565 19.8 2.39565ZM18.4245 8.10727L15.8784 5.56574L2.4 19.0197V21.6044H4.90294L18.4245 8.10727ZM16.8299 1.22804C17.6176 0.441738 18.686 0 19.8 0C20.914 0 21.9824 0.441738 22.7701 1.22804C23.5579 2.01433 24.0004 3.08078 24.0004 4.19278C24.0004 5.30477 23.5579 6.37122 22.7701 7.15752L5.89706 24H0V18.0274L16.8299 1.22804Z" />
    </svg>

  )
}

export default PencilIcon
